module.exports = __webpack_public_path__ + "img/sportsiq.31086767.jpg";